/**
 * @file Discover Album Folder Navigation container.
 */

import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { AlbumFolderHierarchy } from '../../graphql/queries/album-folder';
import DiscoverAlbumFolderNavigation from '../../components/discover/DiscoverAlbumFolderNavigation';
import { createAlbumFolderTree } from '../../util/album-folder';

const withAlbumFolderHierarchy = graphql(AlbumFolderHierarchy, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
    notifyOnNetworkStatusChange: true,
  }),
  props: ({ data: { albumFolder, loading } }) => {
    if (albumFolder) {
      const currentAlbumFolder = {
        ...albumFolder,
        album_folder_hierarchy: undefined,
      };

      const folders = [...(albumFolder?.album_folder_hierarchy?.records ?? [])];

      const [rootAlbumFolder] = createAlbumFolderTree(folders);
      return {
        loading,
        currentAlbumFolder,
        rootAlbumFolder,
      };
    }

    return {
      loading,
    };
  },
});

export default compose(
  withRouter,
  withAlbumFolderHierarchy,
)(DiscoverAlbumFolderNavigation);
